import type { Layout } from "react-grid-layout/legacy";
import type { BackendDashboardSpec } from "../Processing/types";
import { trainingAPI } from "../../../api/TrainingAPI";
import { mapBackendDashboardSpec, type DashboardSpecWidget } from "./mapDashboardSpec";

export { mapBackendDashboardSpec };
export type { DashboardSpecWidget };

export interface DashboardSpecResult {
  name: string;
  widgets: DashboardSpecWidget[];
  layout: Layout;
  /** Raw backend-shaped spec (Dashboard.info), forwarded verbatim to the
   * insights endpoint after load. Null for a new/empty dashboard. */
  backendSpec: BackendDashboardSpec | null;
}

export async function fetchDashboardSpec(
  dashboardId: string,
): Promise<DashboardSpecResult> {
  const raw: any = await trainingAPI.getDashboardSpec(dashboardId);
  const info = raw.info ?? {};
  const { widgets, layout } = mapBackendDashboardSpec(info);

  return {
    name: raw.name ?? "Untitled Dashboard",
    widgets,
    layout,
    backendSpec: info.widgets ? (info as BackendDashboardSpec) : null,
  };
}
